import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core'
import { getBarriersByForm } from '../../../../../../services/Elegibilidad/get'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../../../context/EligibilityContext'

const Table393 = ({ idElegibilityForm }) => {
  // const { step } = useFormElegibilidad()
  const [state] = useEligibility()

  const [tableData, setTableData] = useState([])

  const getDataTable = async () => {
    try {
      const response = await getBarriersByForm(idElegibilityForm)
      if (response.Code === 200) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const columns = [
    {
      title: 'MIPYME / Agricultores ¿Alguna vez tuvo problemas para...',
      field: 'BarrierDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
    },
    {
      title: 'Frecuencia',
      field: 'opc',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      // editComponent: (rowData) => (
      //   <RadioGroup
      //     aria-labelledby="demo-radio-buttons-group-label"
      //     name="radio-buttons-group"
      //     row
      //     onChange={(e) => (optionValue = e.target.value)}
      //   >
      //     <FormControlLabel value="NU" control={<Radio />} label="Nunca" />
      //     <FormControlLabel
      //       value="NM"
      //       control={<Radio />}
      //       label="Normalmente"
      //     />
      //     <FormControlLabel value="AM" control={<Radio />} label="A Menudo" />
      //   </RadioGroup>
      // ),
      render: (rowData) => (
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={rowData.IdOption}
          name="radio-buttons-group"
          row
        >
          <FormControlLabel
            value="NU"
            control={<Radio />}
            disabled
            label="Nunca"
          />
          <FormControlLabel
            value="NM"
            control={<Radio />}
            label="Normalmente"
            disabled
          />
          <FormControlLabel
            value="AM"
            control={<Radio />}
            label="A Menudo"
            disabled
          />
        </RadioGroup>
      ),
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',
              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            // icons={{
            //   Add: () => (
            //     <Button
            //       variant="contained"
            //       color="success"
            //       style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
            //       startIcon={<AddIcon style={{ color: 'white' }} />}
            //     >
            //       Agregar otra barrera
            //     </Button>
            //   ),
            //   Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
            //   Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            // }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table393)
